module.exports = __webpack_public_path__ + "img/swiper_03.47501ad6.jpg";